import APPCONFIG from 'constants/Config';
import { CPM_TOGGLE_SIDEBAR } from 'constants/ActionTypes';

const initialSettings = APPCONFIG.cpmSidebar;

const sidebar = (state = initialSettings, action) => {
  switch (action.type) {
    case CPM_TOGGLE_SIDEBAR:
      return { ...state, isCpmSidebarOpen: !state.isCpmSidebarOpen };
    default:
      return state;
  }
};

export default sidebar;



// WEBPACK FOOTER //
// ./reducers/cpm/sidebar/sidebar.js